import LongPackage from 'long';
import { cloneDeep } from 'lodash';
export const fromJson = (typeName, payload, pathInPayload) => {
    const clonedPayload = cloneDeep(payload);
    serializer[typeName].fromJson(clonedPayload, pathInPayload);
    return clonedPayload;
};
export const toJson = (typeName, payload, pathInPayload) => {
    const clonedPayload = cloneDeep(payload);
    serializer[typeName].toJson(clonedPayload, pathInPayload);
    return clonedPayload;
};
export const batchFromJson = (payload, serializationRequests) => {
    const clonedPayload = cloneDeep(payload);
    serializationRequests.forEach((serializationRequest) => {
        serializer[serializationRequest.typeName].fromJson(clonedPayload, serializationRequest.pathInPayload);
    });
    return clonedPayload;
};
export const batchToJson = (payload, serializationRequests) => {
    const clonedPayload = cloneDeep(payload);
    serializationRequests.forEach((serializationRequest) => {
        serializer[serializationRequest.typeName].toJson(clonedPayload, serializationRequest.pathInPayload);
    });
    return clonedPayload;
};
export const NULL_VALUE_SERIALIZATION_KEY = 'google.protobuf.NullValue';
export const DURATION_SERIALIZATION_KEY = 'google.protobuf.Duration';
export const TIMESTAMP_SERIALIZATION_KEY = 'google.protobuf.Timestamp';
export const FIELD_MASK_SERIALIZATION_KEY = 'google.protobuf.FieldMask';
export const FIELD_MASK_ARRAY_SERIALIZATION_KEY = 'google.protobuf.FieldMaskArray';
export const INT_64_SERIALIZATION_KEY = 'int64';
export const FIXED_64_SERIALIZATION_KEY = 'fixed64';
export const SFIXED_64_SERIALIZATION_KEY = 'sfixed64';
export const UINT_64_SERIALIZATION_KEY = 'uint64';
export const SINT_64_SERIALIZATION_KEY = 'sint64';
export const UINT_64_VALUE_SERIALIZATION_KEY = 'google.protobuf.UInt64Value';
export const BYTES_SERIALIZATION_KEY = 'bytes';
export const INT_64_VALUE_SERIALIZATION_KEY = 'google.protobuf.Int64Value';
const typeTransformer = (jsonSerializer, jsonDeserializer) => {
    return {
        toJson: (payload, pathInPayload) => updatePathRecursively(payload, pathInPayload, jsonSerializer),
        fromJson: (payload, pathInPayload) => updatePathRecursively(payload, pathInPayload, jsonDeserializer),
    };
};
const jsonDeserializeLong = (longAsString) => longAsString !== undefined ? LongPackage.fromValue(longAsString) : undefined;
const jsonSerializeLong = (longObject) => longObject !== undefined ? longObject.toString() : undefined;
const longTransformer = typeTransformer(jsonSerializeLong, jsonDeserializeLong);
const jsonSerializeTimestamp = (dateObject) => dateObject
    ? Array.isArray(dateObject)
        ? dateObject.map((d) => d.toISOString())
        : dateObject.toISOString()
    : undefined;
const jsonDeserializeTimestamp = (dateString) => dateString
    ? Array.isArray(dateString)
        ? dateString.map((str) => new Date(Date.parse(str.toString())))
        : new Date(Date.parse(dateString.toString()))
    : undefined;
const jsonSerializeNullValue = () => null;
const jsonDeserializeNullValue = () => null;
const jsonSerializeFieldMask = (fieldMaskObject) => fieldMaskObject;
const jsonDeserializeFieldMask = (fieldMaskString) => fieldMaskString;
const jsonSerializeFieldMaskArray = (fieldMaskObject) => fieldMaskObject && Array.isArray(fieldMaskObject)
    ? fieldMaskObject.join(',')
    : undefined;
const jsonDeserializeFieldMaskArray = (fieldMaskString) => fieldMaskString ? fieldMaskString.split(',') : undefined;
const jsonDeserializeBytes = (bytes64bitEncodedString) => {
    const asCharCode = (c) => c.charCodeAt(0);
    const decode = (chars) => Uint8Array.from(atob(chars), asCharCode);
    return decode(bytes64bitEncodedString);
};
const jsonSerializeBytes = (bytesArray) => {
    const output = [];
    for (let i = 0, length = bytesArray.length; i < length; i++) {
        output.push(String.fromCharCode(bytesArray[i]));
    }
    return btoa(output.join(''));
};
const jsonSerializeDuration = (durationObject) => {
    if (durationObject &&
        durationObject.seconds !== undefined &&
        durationObject.nanos !== undefined) {
        const nanosString = durationObject.nanos.toString().length < 9
            ? '000000000'.substr(0, 9 - durationObject.nanos.toString().length) +
                durationObject.nanos.toString()
            : durationObject.nanos.toString();
        return durationObject.seconds.toString() + `.` + nanosString + `s`;
    }
    return undefined;
};
const jsonDeserializeDuration = (durationString) => durationString
    ? {
        seconds: LongPackage.fromString(durationString.substr(0, durationString.indexOf('.'))),
        nanos: Number.parseInt(durationString.substr(durationString.indexOf('.') + 1, durationString.length - 1), 10),
    }
    : undefined;
/**
 * traverse the payload recursively and apply the transformation on the end of the path.
 * in case we have an array as part of the path we assume the array elements are all of the same type and we apply the
 * transformation on all the path continuations of all the array elements
 * @param payload
 * @param pathToUpdate
 * @param applyTransformation
 */
const updatePathRecursively = (payload, pathToUpdate, applyTransformation) => {
    if (pathToUpdate.length === 1) {
        // recursion end condition
        if (payload !== undefined && payload !== null) {
            // all the fields are optional so only if we have an object we will update it.
            const transformedPayload = applyTransformation(payload[pathToUpdate[0]]);
            if (transformedPayload !== undefined && transformedPayload !== null) {
                payload[pathToUpdate[0]] = transformedPayload;
            }
        }
    }
    else {
        // go down one level deep in the recursion
        if (payload !== undefined && payload !== null) {
            // all the fields are optional so only if we have an object we will continue the recursion.
            const currentPayloadSubTree = payload[pathToUpdate[0]];
            if (Array.isArray(currentPayloadSubTree)) {
                // traverse arrays
                currentPayloadSubTree.forEach((objectArrayElement) => updatePathRecursively(objectArrayElement, pathToUpdate.slice(1), applyTransformation));
            }
            else {
                // traverse object with the rest of the path
                updatePathRecursively(currentPayloadSubTree, pathToUpdate.slice(1), applyTransformation);
            }
        }
    }
};
const serializer = {};
serializer[NULL_VALUE_SERIALIZATION_KEY] = typeTransformer(jsonSerializeNullValue, jsonDeserializeNullValue);
serializer[DURATION_SERIALIZATION_KEY] = typeTransformer(jsonSerializeDuration, jsonDeserializeDuration);
serializer[INT_64_VALUE_SERIALIZATION_KEY] = longTransformer;
serializer[INT_64_SERIALIZATION_KEY] = longTransformer;
serializer[FIXED_64_SERIALIZATION_KEY] = longTransformer;
serializer[SFIXED_64_SERIALIZATION_KEY] = longTransformer;
serializer[UINT_64_SERIALIZATION_KEY] = longTransformer;
serializer[SINT_64_SERIALIZATION_KEY] = longTransformer;
serializer[UINT_64_VALUE_SERIALIZATION_KEY] = longTransformer;
serializer[TIMESTAMP_SERIALIZATION_KEY] = typeTransformer(jsonSerializeTimestamp, jsonDeserializeTimestamp);
serializer[FIELD_MASK_SERIALIZATION_KEY] = typeTransformer(jsonSerializeFieldMask, jsonDeserializeFieldMask);
serializer[FIELD_MASK_ARRAY_SERIALIZATION_KEY] = typeTransformer(jsonSerializeFieldMaskArray, jsonDeserializeFieldMaskArray);
serializer[BYTES_SERIALIZATION_KEY] = typeTransformer(jsonSerializeBytes, jsonDeserializeBytes);
//# sourceMappingURL=index.js.map